import React from "react";

import './style.css';

function TestHomeView(){
    return(
        <>
            {/* <h1 style={{marginLeft:'240px'}}>TestHomeView</h1> */}
        </>
    )
}

export default TestHomeView;